import { defineStore } from "pinia";
import { computed, ref, toRefs } from "vue";
export const useHomeStore = defineStore("homeStore", () => {
    // MARK: Initial state
    const initialState = () => ({
        itemInGridView: true,
        itemInSelectionView: false,
        selectedItems: [],
        showShareDialog: false,
        showQRDialog: false,
        qrDialogItem: null,
    });
    const state = ref(initialState());
    const { itemInGridView, itemInSelectionView, selectedItems, showShareDialog, showQRDialog, qrDialogItem, } = toRefs(state.value);
    // MARK: Computed value
    const selectedItemsURLString = computed(() => {
        const urlArr = selectedItems.value.map((item) => {
            return `${getItemDesc(item)}\nhttps://${window.location.host}/listing/${item.id}`;
        });
        return urlArr.join("\n\n");
    });
    // MARK: Function
    const getItemDesc = (item) => {
        const parts = [item.brand ?? ""];
        if (item.model)
            parts.push(` ${item.model}`);
        if (item.model_series)
            parts.push(` ${item.model_series}`);
        if (item.size_diameter) {
            parts.push(` - ${item.size_diameter.replace(/\s/g, "")}`);
        }
        return parts.join("").replace(/[\\\"']/g, "");
    };
    // MARK: Reset
    const reset = () => Object.assign(state.value, initialState());
    // MARK: Return
    return {
        itemInGridView,
        itemInSelectionView,
        selectedItems,
        showShareDialog,
        showQRDialog,
        qrDialogItem,
        selectedItemsURLString,
        reset,
    };
});
